<template>
    <div id="login">
        <el-card class="card">
            <el-form :model="form" label-width="120px">
                <el-form-item label="服务器地址">
                    <el-input v-model="form.ip" />
                </el-form-item>
                <el-form-item label="登录密码">
                    <el-input v-model="form.password" type="password" />
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="onSubmit">保存</el-button>

                </el-form-item>
            </el-form>

        </el-card>

        <el-card class="card">
            <el-form :model="form" label-width="120px">
                <el-form-item label="配置文件">
                    <el-input type="textarea" v-model="configtxt"   class="custom-textarea"></el-input>
                </el-form-item>

                <el-form-item>
                    <el-button type="primary" @click="onSubmit2">保存</el-button>

                </el-form-item>
            </el-form>

        </el-card>


    </div>
</template>

<script setup>
import { onMounted, onUpdated, reactive, ref, watch } from 'vue'
import Api from '@/network'
import OrderInfoDetail from "./adminComponents/orderInfoDetail"
import { request } from '@/network/request'
import { useRouter } from 'vue-router'
import OrderPrint from "./Order-print"

const initData = ref(JSON.parse(localStorage.getItem('initData')))

let configtxt = ref('')
let form = reactive({})
form.password = window.localStorage.getItem('accessToken')
form.ip = window.localStorage.getItem('ip')


window.localStorage.setItem('accessToken', form.password)
window.localStorage.setItem('ip', form.ip)


const onSubmit = () => {
    console.log(form)
    window.localStorage.setItem('accessToken', form.password)
    window.localStorage.setItem('ip', form.ip)

    .01
}
const onSubmit2 = () => {
    Api.request({
        url: '/admin/upConfig',
        method: 'post',
        data: {
            config: configtxt.value
        }
    })

}


</script>



<style lang="less">
.card {
    width: 800px;
}
.custom-textarea .el-textarea__inner {
  height: 380px;      /* 固定高度 */
  min-height: 120px;  /* 禁止自动收缩 */
}
</style>